document.addEventListener("turbolinks:load", function() {
    if($("body").data("controller") == "songs") {
        let tableSongs;
        let emotion_id;
        let cancelUploading = false;
        let emotion_ids = []
        if ($("#song_emotion_ids").val() != undefined)
            emotion_ids = $("#song_emotion_ids").val().split(",").map((num) => parseInt(num));

        document.addEventListener("turbolinks:before-cache", function() {
            if (tableSongs != null) {
                tableSongs.destroy();
            }
        })

        tableSongs = $('#table-songs').DataTable({
            'initComplete': function(settings){
                var api = this.api();
       
                api.cells(
                   api.rows(function(idx, data, node){
                      return ($(node).data('related')) ? true : false;
                   }).indexes(),
                   0
                ).checkboxes.disable();
            },
            'columnDefs': [
                {
                   'targets': 0,
                   'checkboxes': {
                        'selectRow': false,
                        'selectCallback': function(nodes, selected) {
                            refresh_selected_elements()
                        }
                    }
                }
            ],
            'select': {
                'style': 'multi',
                "selector": 'td:first-child'
            },
            "bPaginate": true,
            "bFilter": true,
            "bInfo": false,
            "bLengthChange": false,
            "searching": true,
            "stateSave": false,
            "destroy": true,
            "scrollCollapse": true,
            "oLanguage": {
                "sLengthMenu": "_MENU_ ",
                "sInfo": "Showing <b>_START_ to _END_</b> of _TOTAL_ entries"
            },
            "bAutoWidth": false,
            'order' : [[1,'desc']]
        });
        $("#table-songs_wrapper > div > .col-sm-6:nth-child(1)").addClass("content-left")
        $("#table-songs_wrapper > .row > div:first").append("<div><span>" +
            "<div class='form-check checkbox-circle complete filter-passed'>" + 
                "<input type='checkbox' id='filter-show_not_active' checked>" + 
                "<label for='filter-show_not_active'>Show inactive audios</label>" +
            "</div>" + 
        "</span></div>")

        // toggle active/inactive songs
        $("#filter-show_not_active").on("change", function() {
            if($(this).prop("checked")) {
                $.fn.dataTable.ext.search.pop();
            }
            else {
                $.fn.dataTable.ext.search.push(
                    function(settings, data, dataIndex) {
                       return $(tableSongs.row(dataIndex).node()).attr('data-active') == 'true';
                    }
                 );
            }

            tableSongs.draw();
        })

        $('[data-init-plugin="select2"]').each(function () {
            $(this).select2({
                minimumResultsForSearch: ($(this).attr('data-disable-search') == 'true' ? -1 : 1)
            });
        });
        
        $("#song-input").on("click", function() {
            document.getElementById("upfile").click();
        })
        
        $("#upfile").on("change", function(obj) {
            var video_id = $(".video-success-id").text();
            var file_origine = this
            var file = this.value;
            if (file != "") {
                if (isVideo(this.value)) {
                    var fileName = file.split("\\");
                    document.getElementById("song-input").innerHTML = fileName[fileName.length - 1];
                    $(this).attr("disabled", true)

                    $.ajax({
                        url: "/songs/prepare_song",
                        type: 'PUT',
                        dataType: "json",
                        data: {
                            video_id: video_id
                        },
                        success: function (data) {

                            $("#song-id").val(data.song_id)
                            upload(file_origine, data.song_id)
                        },
                        error: function(data) {
                        }
                    });
                }
                else {
                    $(".song-upload-error").removeClass("hidden")
                }
            }
        })

        function upload(file, song_id) {
            $(".song-progress").removeClass("hidden")
            $(".song-progress .progress").append("<div class='song-progress-upload-length w-100 pt-2 text-center' style='position: absolute; font-weight: bold;'>0%</div>" +
                "<div class='progress-bar progress-bar-striped progress-bar-animated song-progress-upload' role='progressbar' aria-valuenow='75' aria-valuemin='0' aria-valuemax='100' style='margin-right: auto; width: 0%'>" +
            "</div>")

            var uploader = new VideoUploader({
                videoId: song_id,
                file: file.files[0],
                uploadToken: "to5pYv2Li3irOb9HwHTdhkE6",
                retries: 10000000
            })

            uploader.upload().then((video) => {
                $(".song-success-info").removeClass("hidden")
                $(".song-success-id").text(video.videoId)
                $(".song-success-url").text(video.assets.mp4)
                $(".song-success-url").parent().attr("href", video.assets.mp4) 
               
                //$("#video-player").html(video.assets.iframe) 

                $("#song-url").val(video.assets.mp4)
                $("#song-id").val(video.videoId)

                $(".song-progress").addClass("hidden")
                $(".song-upload-success").removeClass("hidden")
                $("#btn-save-song").attr("disabled", false)
                $("#upfile").attr("disabled", false)
            })
            .catch((error) => console.log(error.status, error.message));

            uploader.onProgress((event) => {

                if (cancelUploading) {
                    $(".song-progress .progress div").remove()
                    resetUpload()
                    cancelUploading = false
                }

                percent = (event.uploadedBytes / event.totalBytes) * 100
                percent = Number.parseFloat(percent).toFixed(2)

                if (percent > 100) {
                    percent = 100
                }

                $(".song-progress-upload").css("width", percent  + "%")
                $(".song-progress-upload-length").text(percent  + "%")
            })
            
        }

        // cancel uploading
        $("#song-cancel_uploading").on("click", function() { 
            Swal.fire({
                title: 'Are you sure?',
                text: "The video will be deleted from the server!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    $.ajax({
                        url: "/videos/cancel_uploading/" + $("#video-id").val(),
                        type: 'DELETE',
                        dataType: "json",
                        success: function (data) {
                            cancelUploading = true
                        },
                        error: function(data) {
                        }
                    });
                }
            })
        })

        function resetUpload() {
            $("#song-id").val("")
            $(".song-progress").addClass("hidden")
            $(".song-success-info").addClass("hidden")
            $(".song-progress-upload").css("width", "0%")
            $(".song-progress-upload-length").text("0%")
            $(".song-upload-error").addClass("hidden")
            $("#upfile").attr("disabled", false)
            $("#song-input").text("CLICK TO CHOOSE A FILE")
        }

        function isVideo(filename) {
            var parts = filename.split('.');
            ext = parts[parts.length - 1];

            switch (ext.toLowerCase()) {
              case 'm4v':
              case 'avi':
              case 'mpg':
              case 'mp4':
                // etc
                return true;
            }
            return false;
        }

        const lightbox = GLightbox();
        
        FilePond.registerPlugin(FilePondPluginImagePreview, FilePondPluginFileValidateSize, FilePondPluginFileValidateType);
     
        const pond_image = FilePond.create(document.querySelector('#song-image'), {
            acceptedFileTypes: ['image/png', 'image/jpg', 'image/jpeg'],
            labelIdle: "Drag & Drop your image or <span class='filepond--label-action'> Browse </span>",
            imagePreviewMinHeight: 128,
            imagePreviewMaxHeight: 128,
            imagePreviewHeight: 128,
            allowProcess: false,
            instantUpload: false,
            name: 'song[image]',
            storeAsFile: true,
            credits: {label: "", url: ""} ,
            maxFileSize: 300000,
        });

        const pond_file = FilePond.create(document.querySelector('#song-file'), {
            acceptedFileTypes: ['audio/mp4', 'audio/mp3', 'audio/*', 'audio/mpeg3'],
            labelIdle: "Drag & Drop your audio file or <span class='filepond--label-action'> Browse </span>",
            allowProcess: false,
            instantUpload: false,
            name: 'song[file]',
            storeAsFile: true,
            credits: {label: "", url: ""}
        });

        $("#btn-save-song").on("click", function() {
            $("#form-song").validate()

            if ($("#form-song").valid()) {
                $(".loader").removeClass("hidden")
                $(".btn-cancel").attr("disabled", true)
                $("button[type='submit']").attr("disabled", true)
                
                document.getElementById("form-song").submit()
            }
        })

        // delete song
        $(".delete-song").on("click", function() {
            song_id = $(this).parent().parent().attr("data-song_id")

            Swal.fire({
                title: 'Are you sure?',
                text: "The audio file will be deleted as well!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
              }).then((result) => {
                    if (result.isConfirmed) {
                        destroy(song_id, null)
                    }
              })
        })

        // change state selected elements
        $("#state-selected-elements").on("click", function() {
            Swal.fire({
                title: "Change all selected elements state to ?",
                input: 'select',
                inputOptions: {
                  'true': 'Active',
                  'false': 'Inactive'
                },
                inputPlaceholder: 'Select a state',
                showCancelButton: true,
                inputValidator: (value) => {
                  return new Promise((resolve) => {
                        if (value == "")
                            resolve("Please choose a state")
                        else {
                            changeState(null, value, rows_selected.join(","))
                        }
                  })
                }
              })
        });

        // change state
        $(".change-state").on("click", function() {
            let text = $(this).text() == "true" ? 'Inactive' : 'Active'
            let state = $(this).text() == "true" ? false : true

            Swal.fire({
                title: `Change this song's state to ${text} ?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, change it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    song_id = $(this).parent().parent().attr("data-song_id")
                    changeState(song_id, state)
                }
            })
        })

        //select elements
        $("#table-songs input[type=checkbox]").on("change", function() {
            refresh_selected_elements()
        })
        
        // delete selected elements
        $("#delete-selected-elements").on("click", function() {
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    elements = rows_selected
                    $.each(elements, function(index, rowId){
                        $(`#table-songs tr[data-song_id='${rowId}'] td:nth-child(7)`).html("<b>Deleting...</b>");
                        $(`#table-songs tr[data-song_id='${rowId}'] td:nth-child(6) a`).removeAttr("href")
                        $(`#table-songs tr[data-song_id='${rowId}'] .change-state`).off( "click", "");
                        tableSongs.cells(`tr[data-song_id='${rowId}']`, 0).checkboxes.disable()
                    })

                    destroy(null, rows_selected.join(","))
                }
            })
        })

        function changeState(song_id, state, elements) {
            if (song_id != null) {
                $.ajax({
                    url: "/songs/change_state/" + song_id,
                    type: 'PUT',
                    dataType: "json",
                    data: {
                        state: state
                    },
                    success: function (data) {
                        $(`#table-songs tr[data-song_id='${song_id}'] .change-state`).text(state);
                        $(`#table-songs tr[data-song_id='${song_id}']`).toggleClass("tr-deactivated")
                        $(`#table-songs tr[data-song_id='${song_id}']`).attr("data-active", state)
                        if (state) {
                            $(`#table-songs tr[data-song_id='${song_id}'] .change-state`).addClass("badge-success")
                            $(`#table-songs tr[data-song_id='${song_id}'] .change-state`).removeClass("badge-warning")
                        }
                        else {
                            $(`#table-songs tr[data-song_id='${song_id}'] .change-state`).addClass("badge-warning")
                            $(`#table-songs tr[data-song_id='${song_id}'] .change-state`).removeClass("badge-success")
                        }
                    },
                    error: function(data) {
                    }
                });
            }
            else if (elements != null) {
                $(".total-selected-content").addClass("hidden")

                $.ajax({
                    url: "/songs/change_state",
                    type: 'PUT',
                    dataType: "json",
                    data: {
                        elements_id: elements,
                        state: state
                    },
                    success: function (data) {
                        elements = elements.split(',')
                        
                        $.each(elements, function(index, rowId){
                            $(`#table-songs tr[data-song_id='${rowId}'] .change-state`).text(state);
                            $(`#table-songs tr[data-song_id='${rowId}']`).attr("data-active", state)
                            tableSongs.cells(`tr[data-song_id='${rowId}']`, 0).checkboxes.deselect()

                         
                            if (state == "true") {
                                $(`#table-songs tr[data-song_id='${rowId}'] .change-state`).addClass("badge-success")
                                $(`#table-songs tr[data-song_id='${rowId}'] .change-state`).removeClass("badge-warning")

                                $(`#table-songs tr[data-song_id='${rowId}']`).removeClass("tr-deactivated")
                            }
                            else {
                                $(`#table-songs tr[data-song_id='${rowId}'] .change-state`).addClass("badge-warning")
                                $(`#table-songs tr[data-song_id='${rowId}'] .change-state`).removeClass("badge-success")
                             
                                $(`#table-songs tr[data-song_id='${rowId}']`).addClass("tr-deactivated")
                            }
                            
                        });

                        refresh_selected_elements()

                        Swal.close()
                    },
                    error: function(data) {
                    }
                });
            }
        }

        function destroy(song_id, elements) {
            if (song_id != null) {
                $(`#table-songs tr[data-song_id='${song_id}'] td:nth-child(7)`).html("<b>Deleting...</b>");
                $(`#table-songs tr[data-song_id='${song_id}'] td:nth-child(6) a`).removeAttr("href")
                $(`#table-songs tr[data-song_id='${song_id}']`).addClass("tr-deleting")
                $(`#table-songs tr[data-song_id='${song_id}'] .change-state`).off( "click", "");
                
                tableSongs.cells(`tr[data-song_id='${song_id}']`, 0).checkboxes.disable()
                refresh_selected_elements()

                $.ajax({
                    url: "/songs/" + song_id,
                    type: 'DELETE',
                    dataType: "json",
                    success: function (data) {
                        tableSongs.row($(`tr[data-song_id='${song_id}']`)).remove().draw();

                        if (data.name != null) {
                            messageDeleted = `The song "${data.title}" has been deleted.`
                        }

                    },
                    error: function(data) {
                    }
                });
            }
            else if(elements != null) {
                $(".total-selected-content").addClass("hidden")

                $.ajax({
                    url: "/songs/delete_elements",
                    type: 'DELETE',
                    dataType: "json",
                    data: {
                        elements_id: elements
                    },
                    success: function (data) {
                        elements = elements.split(',')

                        $.each(elements, function(index, rowId){
                            tableSongs.row($(`tr[data-song_id='${rowId}']`)).remove().draw();
                        });

                        $(".total-selected-content").addClass("hidden")
                    },
                    error: function(data) {
                    }
                });
            }
        }

        // select emotion
        $(".select-emotion").on("click", function() {
            $(this).toggleClass("emotion_selected")
            emotion_id = $(this).parent().data("emotion_id")
            if (emotion_ids.indexOf(emotion_id) != -1) {
                emotion_ids.splice(emotion_ids.indexOf(emotion_id), 1);
            }
            else {
                emotion_ids.push(emotion_id)
            }
            
            $("#song_emotion_ids").val(emotion_ids)

            $(".emotion_txt").removeClass("emotion_bold")
            $(this).next(".emotion_txt").toggleClass("emotion_bold")
        })

        function refresh_selected_elements() {
            rows_selected = tableSongs.column(0).checkboxes.selected();

            if (rows_selected.length == 0) {
                $(".total-selected-content").addClass("hidden")
                $(".total-selected-content").css("marginBottom", 0)
                $(".total-selected-content").css("opacity", 0)
            }
            else {
                $(".total-selected-content").removeClass("hidden")
                $(".total-selected-content").animate({
                    marginBottom: 10,
                    opacity: 1
                }, 100, "linear",  function() {
                });
            }
            
            $.each(rows_selected, function(index, rowId){
            });

            let txt = rows_selected.length > 1 ? `${rows_selected.length} elements selected` : `${rows_selected.length} element selected`
            $(".total-selected").text(txt)

            return rows_selected
        }
    }
})